import { createContext, useContext, useState } from "react";
import { DateRange } from "../../../core/types";
import { DateHelper } from "../../../core/helpers/dateHelper";

interface DashboardDateRangeContextProps {
    dateRange: DateRange
    setDateRange: (value: DateRange) => void
}

export const DashboardDateRangeProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [dateRange, setDateRange] = useState<DateRange>(DateHelper.getCurrentWeekDateRange());

    return (
        <DashboardDateRangeContext.Provider value={{ dateRange, setDateRange }}>
            {children}
        </DashboardDateRangeContext.Provider>
    )
}

export const useDashboardDateRange = (): DashboardDateRangeContextProps => {
    const context = useContext(DashboardDateRangeContext)
    if (!context) {
        throw new Error("useDashboardDateRange must be used within a DashboardDateRangeProvider")
    }

    return context
}

const DashboardDateRangeContext = createContext<DashboardDateRangeContextProps|undefined>(undefined)
